import script from "./ViewArticle.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewArticle.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__